module.exports = __webpack_public_path__ + "img/金豆.1154b069.png";